// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

export interface ParsedResponse<T> {
  data: T | undefined;
  responseCode: number | undefined;
  errorCode?: string;
  errorMessage: string | undefined;
  ok: boolean;
}

export interface ErrorResponse {
  error: string;
  message?: string;
  errorCode?: string;
}

export class ServerResponseParser<T> {
  parseResponse(response: Response): Promise<ParsedResponse<T>> {
    if (response.ok) {
      return response.json().then((json: T) => {
        return {
          responseCode: response.status,
          errorMessage: undefined,
          data: json,
          ok: true
        };
      });
    } else {
      return response.json().then((json: ErrorResponse) => {
        return {
          responseCode: response.status,
          errorCode: json.errorCode,
          errorMessage: [json.error, json.message]
            .filter(item => item != undefined)
            .join(" : "),
          data: undefined,
          ok: false
        };
      });
    }
  }
}
